import React, { PureComponent } from 'react';

class Thanks extends PureComponent {
    render(){
        return (
            <div className="thanks section">
                <p>感謝你支持高登新聞台<br/>
                我們將透過電郵確認你的付款支持</p>
            </div>
        );
    }
}
export default Thanks;